import React, { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

/**
 * Select de proiect/regie cu căutare integrată — folosit în Calendar Ore (PersonDetail).
 * opts / regiiOpts: array de [id, label].
 */
export function ProjectSearchSelect({ value, onValueChange, disabled, opts, regiiOpts, hasDayAllocs, testid, placeholder }) {
  const [q, setQ] = useState("");
  const nq = norm(q);
  const match = (label) => !nq || norm(label).includes(nq);
  const fOpts = opts.filter(([, l]) => match(l));
  const fRegii = regiiOpts.filter(([, l]) => match(l));
  const showMagazie = match("magazie");
  const showBirou = match("birou");
  return (
    <Select
      value={value}
      onValueChange={(v) => { setQ(""); onValueChange(v); }}
      disabled={disabled}
      onOpenChange={(open) => { if (!open) setQ(""); }}
    >
      <SelectTrigger className="h-6 text-[10px] px-1 mt-1 border-zinc-200" data-testid={testid}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        <div className="sticky -top-1 z-10 bg-white p-1 border-b border-zinc-100">
          <input
            value={q}
            onChange={(ev) => setQ(ev.target.value)}
            onKeyDown={(ev) => ev.stopPropagation()}
            onPointerDown={(ev) => ev.stopPropagation()}
            placeholder="🔍 Caută proiect..."
            className="w-full h-7 px-2 text-xs border border-zinc-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
            data-testid={`${testid}-search`}
          />
        </div>
        <SelectItem value="__none__">— Niciun proiect —</SelectItem>
        {showMagazie && <SelectItem value="__magazie__"><span className="text-cyan-700 font-semibold">🏪 Magazie</span></SelectItem>}
        {showBirou && <SelectItem value="__birou__"><span className="text-purple-700 font-semibold">🏢 Birou</span></SelectItem>}
        {hasDayAllocs && !nq && <div className="text-[10px] text-zinc-400 px-2 pt-1 pb-0.5 uppercase font-semibold">Alocate pe această zi</div>}
        {fOpts.map(([pid, label]) => (
          <SelectItem key={pid} value={pid}>{label}</SelectItem>
        ))}
        {fRegii.length > 0 && <div className="text-[10px] text-amber-600 px-2 pt-1 pb-0.5 uppercase font-semibold border-t border-zinc-200 mt-1">⚙ Regii</div>}
        {fRegii.map(([rid, label]) => (
          <SelectItem key={rid} value={rid}><span className="text-amber-700 font-semibold">{label}</span></SelectItem>
        ))}
        {fOpts.length === 0 && fRegii.length === 0 && nq && (
          <div className="text-[11px] text-zinc-400 italic px-2 py-2">Niciun rezultat pentru „{q}"</div>
        )}
      </SelectContent>
    </Select>
  );
}
